import { Component } from '@angular/core';
import { SharedService } from '../../../../Services/shared.service';
import { distinctUntilChanged } from 'rxjs';
import { API_End_Point } from '../../../../Services/API_End_Point';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { any } from '@tensorflow/tfjs';

@Component({
  selector: 'app-myplan',
  imports: [RouterModule, CommonModule, FormsModule],
  templateUrl: './myplan.component.html',
  styleUrl: './myplan.component.css'
})
export class MyplanComponent {
  PREP_UserInfo: any;
  PurchasePlansList: any = [];
  PurchasePlansList_Pres: any = [];
  SubjectList: any[] = [];
  Subject: any = "";
  IsShowMessage: boolean = false;

  constructor(public _svc: SharedService, private _router: Router) { }

  ngOnInit(): void {
    this._svc.get_Login_Status().pipe(distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)))
      .subscribe(x => {
        this.PREP_UserInfo = x;
        this.myPurchasePlans();
      });

  }

  myPurchasePlans(): void {
    this.IsShowMessage = false;
    this.SubjectList = [];
    this.PurchasePlansList = [];

    this._svc.GET(API_End_Point.PurchasePlans)
      .subscribe((res) => {
        if (res.result === 'success') {

          this.PurchasePlansList_Pres = (res.data || []).filter((x: any) => x.ClassId == this.PREP_UserInfo.classId);
          if (this.PurchasePlansList_Pres.length > 0) {
            this.SubjectList = this._svc.uniqueBy(this.PurchasePlansList_Pres, "SubjectName");
            // this.Subject = this.SubjectList[0].SubjectName;
            this.Subject = "All";
            this.Subject_Changed();
          }
          else
            this.IsShowMessage = true;
        }
      });
  }
  Subject_Changed() {
    this.PurchasePlansList = this.PurchasePlansList_Pres.filter((x: any) => x.SubjectName == (this.Subject == "All" ? x.SubjectName : this.Subject));
  }

  Switch_Child() {
    this._svc.Switch_Child().then((res: any) => {
      this.ngOnInit();
    })
  }

  openItem(index: number, ebook: string) {
    debugger
  if (ebook.includes('Pre Olympiad')) {
      this._router.navigate(['/MyMockTest']);
    }
   else if (ebook.includes('Question Papers')) {
      this._router.navigate(['/book-details'], { queryParams: { booktype: 3, bname: ebook } });
    } else {
      this._router.navigate(['/book-details'], { queryParams: { booktype: 4, bname: ebook } });

    }
  }
}
